import Cookies from 'universal-cookie';

const cookie = new Cookies();

export const getAuthHeaders = () => ({
  Authorization: `Bearer ${cookie.get('tp-b2b-access-token')}`,
  'Content-Type': 'application/json',
});
